export default __webpack_public_path__ + "18e4f60b5caaa23ccb74a42bd0511727.png";